import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TransferTicketRequest, TransferTicketVerifyRequest } = protos;

export function initiate(transfer: core.TransferTicketRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/transfer',
      type: AppConstants.TRANSFER_INITIATE,
      request: TransferTicketRequest.fromObject(transfer),
      toast: 'Check your email, and verify that you requested this transfer.',
    },
  };
}

export function cancel(purchaseId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/transfer/cancel?purchaseId=${purchaseId}`,
      type: AppConstants.TRANSFER_CANCEL,
    },
  };
}

export function getTransferPurchaseTokenPurchaseOrder(transferPurchaseToken: string): ApiAction {
  return {
    TockApi: {
      getProto: `/transfer/purchase/token/order?purchaseToken=${transferPurchaseToken}`,
      type: AppConstants.TRANSFER_PURCHASE_ORDER_FETCH,
    },
  };
}

export function cancelTransferPurchaseToken(transferPurchaseToken: string): ApiAction {
  return {
    TockApi: {
      getProto: `/transfer/purchase/token/cancel?purchaseToken=${transferPurchaseToken}`,
      type: AppConstants.NULL,
    },
  };
}

export function verifyTransferToken(transferToken: string): ApiAction {
  return {
    TockApi: {
      postProto: '/transfer/token/verify',
      request: TransferTicketVerifyRequest.fromObject({ transferToken }),
      type: AppConstants.NULL,
      toast: 'Transfer verified, email has been sent to the recipient to complete the transfer',
      onError: {
        4028: '', // Transfer not allowed at this time. Try again in 2 hours
        5011: '', // Verification email already sent. Please wait a few minutes
        defaultToOriginal: true,
      },
    },
  };
}

export function clearTransferSelection(): BaseTockAction {
  return {
    type: AppConstants.TRANSFER_CLEAR,
  };
}

export function setTransferInfo(purchase: core.PastPurchase): BaseTockAction {
  return {
    type: AppConstants.TRANSFER_PURCHASE_UPDATE,
    payload: {
      purchase,
    },
  };
}

export function setTransferTo(email: string): BaseTockAction {
  return {
    type: AppConstants.TRANSFER_TO_EMAIL_UPDATE,
    payload: {
      transferToEmail: email,
    },
  };
}

export function setTransferPrice(price: number): BaseTockAction {
  return {
    type: AppConstants.TRANSFER_PRICE_UPDATE,
    payload: {
      transferPrice: price,
    },
  };
}

export function setIsGiftFlow(isGiftFlow: boolean): BaseTockAction {
  return {
    type: AppConstants.TRANSFER_IS_GIFT_FLOW_UPDATE,
    payload: {
      isGiftFlow,
    },
  };
}

export function getPurchase(transferToken: string): ApiAction {
  return {
    TockApi: {
      getProto: `/transfer/token/purchase?token=${transferToken}`,
      type: AppConstants.TRANSFER_VERIFY_GET_PURCHASE,
    },
  };
}
